import * as React from "react";
import { Box, BoxProps, styled } from "@mui/material";

export interface RequiredIndicatorProps extends BoxProps {
  color?: string;
}

const RequiredIndicator: React.FC<RequiredIndicatorProps> = ({ color = "error.main", ...otherProps }) => {
  return <StyledBox bgcolor={color} {...otherProps} />;
};

export default RequiredIndicator;

const StyledBox = styled(Box)(({ theme }) => ({
  width: 6,
  height: 6,
  borderRadius: 6,
}));
